__turbopack_context__.v({
  "badge": "_SyclW_badge",
  "badges": "_SyclW_badges",
  "modal": "_SyclW_modal",
  "small": "_SyclW_small",
  "title": "_SyclW_title",
});
